// Nuclear Tabs Quick Fix
// Simple script to diagnose and fix nuclear tab issues

(function() {
  'use strict';
  
  console.log('🔧 Nuclear Tabs Quick Fix - Starting diagnostic...');
  
  // Wait for DOM to be ready
  function initTabsFix() {
    const tabBtns = document.querySelectorAll('.NUCLEAR-tab-btn');
    const tabPanels = document.querySelectorAll('.NUCLEAR-tab-panel');
    
    console.log(`Found ${tabBtns.length} tab buttons and ${tabPanels.length} tab panels`);
    
    if (tabBtns.length === 0 || tabPanels.length === 0) {
      console.error('❌ Nuclear tabs not found in DOM');
      return;
    }
    
    // Debug current state
    tabBtns.forEach((btn, index) => {
      const computedStyle = window.getComputedStyle(btn);
      console.log(`Button ${index} (${btn.dataset.nuclearTab}):`, {
        visible: computedStyle.display !== 'none',
        clickable: computedStyle.pointerEvents !== 'none',
        zIndex: computedStyle.zIndex,
        position: computedStyle.position
      });
    });
    
    // Simple tab switching function
    function switchTab(targetTab) {
      console.log(`🔄 Switching to tab: ${targetTab}`);
      
      // Remove active from all buttons
      tabBtns.forEach(btn => {
        btn.classList.remove('NUCLEAR-active');
      });
      
      // Hide all panels
      tabPanels.forEach(panel => {
        panel.classList.remove('NUCLEAR-show');
      });
      
      // Activate target button
      const targetBtn = document.querySelector(`[data-nuclear-tab="${targetTab}"]`);
      if (targetBtn) {
        targetBtn.classList.add('NUCLEAR-active');
        console.log(`✅ Activated button: ${targetTab}`);
      } else {
        console.error(`❌ Button not found: ${targetTab}`);
      }
      
      // Show target panel
      const targetPanel = document.querySelector(`[data-nuclear-panel="${targetTab}"]`);
      if (targetPanel) {
        targetPanel.classList.add('NUCLEAR-show');
        console.log(`✅ Showed panel: ${targetTab}`);
      } else {
        console.error(`❌ Panel not found: ${targetTab}`);
      }
    }
    
    // Remove all existing event listeners and add fresh ones
    tabBtns.forEach(btn => {
      // Clone the button to remove all event listeners
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      // Add simple click handler
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const tabName = this.dataset.nuclearTab;
        console.log(`🖱️ Tab clicked: ${tabName}`);
        switchTab(tabName);
      });
      
      console.log(`✅ Added click handler to: ${newBtn.dataset.nuclearTab}`);
    });
    
    // Force proper styling
    const style = document.createElement('style');
    style.textContent = `
      .NUCLEAR-tab-btn {
        position: relative !important;
        z-index: 999999 !important;
        pointer-events: auto !important;
        cursor: pointer !important;
        user-select: none !important;
      }
      
      .NUCLEAR-tab-panel {
        display: none !important;
      }
      
      .NUCLEAR-tab-panel.NUCLEAR-show {
        display: block !important;
        opacity: 1 !important;
        visibility: visible !important;
      }
      
      .NUCLEAR-tab-btn.NUCLEAR-active {
        color: #ffffff !important;
      }
    `;
    document.head.appendChild(style);
    
    // Initialize with description tab active
    switchTab('description');
    
    // Add global test functions
    window.testNuclearTabs = function() {
      console.log('🧪 Testing all nuclear tabs...');
      ['description', 'sizing', 'shipping'].forEach(tab => {
        setTimeout(() => switchTab(tab), 1000);
      });
    };
    
    window.switchNuclearTab = switchTab;
    
    console.log('✅ Nuclear tabs fix complete!');
    console.log('💡 Test with: testNuclearTabs() or switchNuclearTab("sizing")');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTabsFix);
  } else {
    initTabsFix();
  }
  
})();
